import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ITab } from '../../models/index.model';
import { TranslatePipe } from "../../pipes/translate.pipe";
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-form-tabs-header',
    templateUrl: './form-tab-headers.component.html',
    styleUrls: ['./form-tab-headers.component.scss'],
    imports: [NgClass, AsyncPipe, TranslatePipe]
})
export class FormTabHeadersComponent implements OnInit {
  @Input() selectedIndex:number
  @Input() tabs: ITab[];
  @Output() selectedIndexChange = new EventEmitter<number>();
  constructor() {}

  ngOnInit(): void {
    this.selectedIndex=0
  }
  changeTab(index: number) {
    this.selectedIndex = index;
    this.selectedIndexChange.emit(index);
  }
}
